// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2T91S","footer":"ReportModalFilter_footer__2znXF"};